import uuid from '../utils/uuid.utils';

export class AuthenticateEvent {
  static Status = {
    DENIED: 'denied',
    VERIFIED: 'verified',
  };

  static authenticate(extraData = {}) {
    window.__CAAS__.triggerNative(
      window.__CAAS__.events.authenticatePasscode,
      uuid(),
      {
        ...extraData,
      },
    );
  }
}
